import { render, staticRenderFns } from "./TableBlueSummary.vue?vue&type=template&id=2aca53f4&scoped=true&"
import script from "./TableBlueSummary.vue?vue&type=script&lang=js&"
export * from "./TableBlueSummary.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueSummary.vue?vue&type=style&index=0&id=2aca53f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca53f4",
  null
  
)

export default component.exports